// extracted by mini-css-extract-plugin
module.exports = {"container":"AidOptimizer_container__3UVTL"};